import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import NotificationsCurrent from 'Features/Notifications/Notifications.Current';
import NotificationsArchive from 'Features/Notifications/Notifications.Archive';
import { NotificationsWrapper } from './NotificationsWrapper';

export default function NotificationsRouter() {
  return (
    <Routes>
      <Route path="/" element={<NotificationsWrapper />}>
        <Route index element={<Navigate to="current" replace />} />
        <Route path="current" element={<NotificationsCurrent />} />
        <Route path="archive" element={<NotificationsArchive />} />
        <Route path="*" element={<Navigate to="current" replace />} />
      </Route>
    </Routes>
  );
}
